module.exports = __webpack_public_path__ + "img/templates.0d1cbcd0.svg";